import { ForgotPasswordBody } from "@models/sleeper/sleeper.model";

export class ForgotPassword {
  static readonly type = '[ForgotPassword] ForgotPasswordBody';
  constructor(public payload: ForgotPasswordBody) { }
}

export class ResetForgotPasswordState {
  static readonly type = '[ForgotPassword] ResetForgotPasswordState';
}